import { configureStore, combineReducers } from "@reduxjs/toolkit";
import datasetSliceReducer from "./dataset/datasetSlice";
import headerSliceReducer from "./header/headerSlice";
import stickySliceReducer from "./sticky/stickySlice";
import filteredArchiveSliceReducer from "./filter/filteredArchiveSlice";

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }
  return combineReducers({
    datasetSlice: datasetSliceReducer,
    headerSlice: headerSliceReducer,
    stickySlice: stickySliceReducer,
    filteredArchiveSlice: filteredArchiveSliceReducer,
  })(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
